import { render, staticRenderFns } from "./NotificationType.vue?vue&type=template&id=b8dedd88&scoped=true&"
import script from "./NotificationType.vue?vue&type=script&lang=js&"
export * from "./NotificationType.vue?vue&type=script&lang=js&"
import style0 from "./NotificationType.vue?vue&type=style&index=0&id=b8dedd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dedd88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
